import * as React from 'react';
import { createPortal } from 'react-dom';
import { SelectValue } from 'antd/lib/select';
import { Select } from 'antd';
import ClickAwayListener from '../click-away-listener';
import StupidSelectStore, { TSelectValue } from './store';


export interface IStupidDropdownSelectProps {
  store: StupidSelectStore;
}

let counter = 0;
class StupidDropdownSelect extends React.Component<IStupidDropdownSelectProps>{
  private node: HTMLDivElement | null = null;

  private dropdownSelectRef: React.RefObject<Select> = React.createRef();

  private dropdownClassName = `StupidDropdownSelect-${counter++}`;

  public componentWillMount() {
    this.node = document.createElement('div');
    document.body.appendChild(this.node);
  }

  public componentWillUnmount() {
    document.body.removeChild(this.node!);
    this.node = null;
  }

  private getHostNode = () => {
    return document.querySelector('.' + this.dropdownClassName);
  }


  private insertSelectedValue = (value: TSelectValue) => {
    const { store } = this.props;
    store.close();
    store.onSelect(value as any);
  }

  private onDropdownVisibleChange = (open: boolean) => {
    if (!open) {
      this.props.store.close();
    }
  }

  private onChange = (value: SelectValue) => {
    const { store } = this.props;
    const { isMultiple } = store;
    if (!isMultiple) {
      this.insertSelectedValue(value as TSelectValue);
    } else {
      store.setValue(value as TSelectValue);
    }
  }

  private close = () => {
    const { store } = this.props;
    const { visible, isMultiple } = store;
    if (visible && isMultiple) {
      store.close();
      this.insertSelectedValue(store.value || []);
    }

  }

  public render() {
    const { visible, position, options, value, isMultiple } = this.props.store;
    const { left, top } = position;
    const styles: any = {
      left, top,
      width: 0, height: 0, padding: 0,
      position: 'absolute', border: 'none',
      overflow: 'hidden'
    };

    return createPortal(
      <ClickAwayListener
        onClickAway={this.close}
        getChildNode={this.getHostNode}
      >
        <Select
          dropdownClassName={this.dropdownClassName}
          ref={this.dropdownSelectRef}
          open={visible}
          style={styles}
          value={value}
          mode={isMultiple ? 'multiple' : undefined}
          onChange={this.onChange}
          onDropdownVisibleChange={this.onDropdownVisibleChange}
        >
          {options.map(option => {
            const key = option.value || option.name;
            return (
              <Select.Option key={key} value={option.value} >
                {option.name}
              </Select.Option>
            );
          })}
        </Select>
      </ClickAwayListener>,
      this.node!
    );
  }
}

export default StupidDropdownSelect;
